export default "__VITE_ASSET__C6VMK03j__"